import styled from "styled-components"
import { Link } from "react-router-dom"

const StyledHeader = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  justify-content: flex-end;
  align-items: center;
  padding: 0.75rem 2rem;
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
`

const LinkButton = styled(Link)`
  text-decoration: none;
  font-size: 1rem;
  text-transform: uppercase;
  font-weight: 200;
  color: white;
  background-color: rgba(0,0,0,0.75);
  padding: 0.5rem 1.5rem;
  cursor: pointer;
`

const HeaderLinks = () => {
  return (
    <StyledHeader>
      <LinkButton to="/">
        Sylhet Relief
      </LinkButton>
      <LinkButton to="/donate">
        Donate
      </LinkButton>
      <LinkButton to="/about-us">
        About Us
      </LinkButton>
    </StyledHeader>
  )
}

export default HeaderLinks